module.exports = __webpack_public_path__ + "img/nueva_venta.5e150039.png";